const gmail = {
  inbox: "Входящие",
  unread: "Непрочитанные",
  from: "От",
  noMessages: "Нет новых сообщений",
  noAccount: "Аккаунт Gmail не подключён",
  connectAccount: "Подключить аккаунт в Настройках",
  openInGmail: "Открыть в Gmail",
  refreshing: "Обновление...",
} as const;
export default gmail;
